// extracted by mini-css-extract-plugin
export default {"container":"_2L1l8","item":"_1oT4G","separator":"_3OGyu","link":"_2rTCt"};